import { Toggle } from '@swaggerhub-portal/component-library'
import clsx from 'clsx'
import { t } from 'i18next'

import { APIRenderers, OpenAPIRendererState } from '~/types/api'

export const OpenAPIRendererToggle = ({
  onToggle = () => {},
  renderer,
}: {
  onToggle?: (value: boolean) => void;
  renderer?: APIRenderers | OpenAPIRendererState;
}) => (
  <div className="flex items-center text-body3">
    <div className={clsx('mx-2 text-neutral-70 dark:text-neutral-40', renderer === APIRenderers.ELEMENTS && 'font-bold')}>
      {t('components.ui.apiViewer.renderer.toggle.left.label')}
    </div>
    <Toggle
      id="openapiRenderer"
      name="openapiRenderer"
      aria-label={t('components.ui.apiViewer.renderer.toggle.ariaLabel')}
      onChange={onToggle}
      fixedColor={true}
      checked={renderer === APIRenderers.SWAGGER_UI}
      className="bg-consumer-blue dark:bg-dark-consumer-blue"
    >
      <div className={clsx('dark:text-neutral-40', renderer === APIRenderers.SWAGGER_UI && 'font-bold')}>
        {t('components.ui.apiViewer.renderer.toggle.right.label')}
      </div>
    </Toggle>
  </div>
)